import '../App.css';
import {List, ListItem, Box, Button, Select, MenuItem, Typography} from '@mui/material/';
import TextInput from '../components/TextInput';
import SingleSelect from '../components/SingleSelect';
import MultiDropdown from '../components/MultiDropdown';
import MultiSelect from '../components/MultiSelect';
import TextBox from '../components/TextBox';
import SortableList from '../components/SortableList';
import RankList from '../components/RankList'
import Dropdown from '../components/Dropdown';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import languages from './../json/languages'
import axios from "axios";
import ImageUpload from '../components/ImageUpload';
import DayTimePicker from '../components/DayTimePicker';
import Scale from '../components/Scale';
import moment from 'moment';
import * as constants from './../constants'
import MenuAppBar from "../components/MenuAppBar";
import countries from "../json/countries.json";

function MentorForm() {
    const [error, setError] = useState('')
    const [playedSports, setPlayedSports] = useState(false)

    const validationSchema = Yup.object().shape({
        q1: Yup.array().of(
            Yup.string()
        ).required('(This question is required)').test('check-min-slots',  '(Only select one if you want to select "Prefer not to say")',
            function(value) {
                let valid = true
                if (value.length > 1 && value.includes("Prefer not to say")) {
                    valid = false
                }
                return valid
            })
            .min(1, '(Please select at least one option)')
            .max(5, '(Please select at least one option)'),
        q2: Yup.string().required('(This question is required)'),
        q3: Yup.string().test('sports', '(This question is required)',
            function(value) {
                setPlayedSports(false)
                if (value === "Yes") {
                    setPlayedSports(true)
                    return true
                } else if (value === "No") {
                    return true
                } else {
                    return false
                }
            }),
        q4: Yup.string().test('sportsName',  '(This question is required)',
            function(value) {
                if (playedSports) {
                    if (value === undefined || value === "" || value === null) return false
                    return true
                } else {
                    return true
                }
            }),
        q5: Yup.array().of(
            Yup.object().shape({
                code: Yup.string(),
                name: Yup.string(),
                nativeName: Yup.string()
          })).required('This question is required'),
        q7: Yup.array().of(
            Yup.object().shape({
                id: Yup.string(),
                text: Yup.string(),
          })).required('This question is required')
            .test('check-min-slots',  '(Please select one of each)',
        function(value) {
            let valid = false
            if (value[0].text !== value[1].text && value[0].text !== value[2].text && value[1].text !== value[2].text) {
                valid = true
            }
            return valid
        }),
        q8: Yup.array().of(
            Yup.object().shape({
                id: Yup.string(),
                text: Yup.string(),
          })).required('This question is required')
            .test('check-min-slots',  '(Please select one of each)',
                function(value) {
                    let valid = false
                    if (value[0].text !== value[1].text && value[0].text !== value[2].text && value[1].text !== value[2].text) {
                        valid = true
                    }
                    return valid
                }),
        q9: Yup.array().of(
            Yup.string().required()
            ).required('(This question is required)')
            .min(2, '(Please select two options)')
            .max(2, '(Please select two options)'),
        q10: Yup.array().of(
            Yup.string()
            ).required('(This question is required)').test('check-min-slots',  '(Only select one if you want to select "None of the above")',
            function(value) {
                let valid = true
                if (value.length > 1 && value.includes("None of the above")) {
                    valid = false
                }
                return valid
            })
            .min(1, '(Please select at least one option)')
            .max(5, '(Please select at least one option)'),
        q11: Yup.array().of(
            Yup.object().shape({
                name: Yup.string(),
                count: Yup.number(),
                slots: Yup.array().of(Yup.object().shape({
                    time: Yup.string(),
                    timezone: Yup.string()}
                ))
          })).required('This question is required')
          .test('check-min-slots', '(Please add at least one slot)',
            function(value) {
                let valid = false
                value.map(day => (
                    day.slots.map(slot => {
                        if(slot.time!=='' && slot.timezone!=='' && slot.time !== undefined && slot.timezone !== undefined){
                            valid = true
                        }
                    })
                ))
                return valid
            })
            .test('check-valid-slots', '(Please correct the invalid slot)', 
            function(value) {
                let valid = true

                value.map(day => (
                    day.slots.map(slot => {
                        if(slot.time === '' || slot.timezone === '' || slot.time === undefined || slot.timezone === undefined){
                            valid = false
                        }
                    })
                ))
                return valid
            }),
        q12: Yup.string().required('(This question is required)'),
        q13: Yup.string().required('(This question is required)'),
        q14: Yup.string().required('(This question is required)'),
        q15: Yup.string().required('(This question is required)'),
        q16: Yup.string().oneOf(['I accept'], '(If you would like to decline, please send an email to tracey@athleda.org)' ).required('(This question is required)')
      });
    
    const { control, handleSubmit, formState: { errors }, setValue } = useForm({ mode: 'all', resolver: yupResolver(validationSchema)});

    const getTopMentors = (data) => {
        window.scrollTo(0, 0)
        axios.post(constants.serverURL + "submitMentorSurvey", {data},
            {
                withCredentials: true
            }).then(response => {
                window.location.href = constants.websiteURL + "#/uploadImage"
            }).catch((error) => {
                if (error.request.responseText === 'expired token') {
                    window.location.href = constants.websiteURL + '#/refreshToken?redirect=mentorform'
                } else {
                    setError(error.request.responseText)
                }
            })
    }
    const onError = (data) => {
        setError('One or more of the required questions have not been answered')
        window.scrollTo(0, 0)
    }

    return(
        <div>
            <MenuAppBar title="Mentor Survey" signedIn={true}></MenuAppBar>
            <form className='screen'>
                <Box className="box">
                <List>
                    {
                        error &&
                        <ListItem sx={{ p:2, my:1.5}} className='question-block'>
                            <Typography className="font-16 error-message">{error}</Typography>
                        </ListItem>
                    }
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <MultiSelect
                            name={"q1"}
                            control={control}
                            question={"1. How do you identify yourself? It will help us make better connections for you."}
                            options = {[
                                "I identify as African",
                                "I identify as American Indian or Alaska Native",
                                "I identify as Asian",
                                "I identify as Black or African American",
                                "I identify as European",
                                "I identify as Hispanic or Latino",
                                "I identify as Native Hawaiian or Other Pacific Islander",
                                "I identify as White",
                                "I identify as some other race",
                                "Prefer not to say"
                            ]}
                            max={5}
                            required={true}
                            errors={errors.q1}
                        />
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <SingleSelect
                            name={"q2"}
                            control={control}
                            question={"2. How do you identify?"}
                            options = {[
                                "Male (including transgender men)",
                                "Female (including transgender women)",
                                "Non-binary",
                                "Gender-fluid",
                                "Agender",
                                "Other",
                                "Prefer not to say"
                            ]}
                            required={true}
                            errors={errors.q2}/>
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <SingleSelect
                        name={"q3"}
                        control={control}
                        question={"3. Were you a former student athlete?"}
                        options = {[ "Yes", "No"]}
                        required={true}
                        errors={errors.q3}/>
                    </ListItem>
                    {
                        playedSports &&
                        <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                            <TextInput
                            name={"q4"}
                            control={control}
                            question={"3.1. What sport did you play?"}
                            required={true}
                            errors={errors.q4}/>
                        </ListItem>
                    }
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <MultiDropdown
                        name={"q5"}
                        control={control}
                        question={"4. Other than English, which languages are you fluent in?"}
                        options={languages}
                        label={"Select language(s)"}
                        required={false}
                        errors={errors.q5}/>
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <SortableList
                            name={"q7"}
                            control={control}
                            setValue={setValue}
                            question={"5. Rank your strengths as a mentor in these categories"}
                            helper={["(From highest to lowest)"]}
                            items={[
                            { id: "1", text: "My industry expertise" },
                            { id: "2", text: "My ability to invoke trust and create an accountable growth mindset"},
                            { id: "3", text: "My ability to relate to my mentee and build their brand"}]}
                            required={true}
                            errors={errors.q7}/>
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <SortableList
                            name={"q8"}
                            control={control}
                            setValue={setValue}
                            question={"6. Rank your strengths as a mentor in these categories"}
                            helper={["(From highest to lowest)"]}
                            items={[
                            { id: "1", text: "My ability to support my mentees health mentally and socially" },
                            { id: "2", text: "My ability to enhance their network and confidence" },
                            { id: "3", text: "My ability to be a guide along a STEM career path they are exploring" }]}
                            required={true}
                            errors={errors.q8}/>
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <MultiSelect
                            name={"q9"}
                            control={control}
                            question={"7. What are the top 2 areas listed below that you can provide support with?"}
                            options = {[ "Building brand/Elevator pitch/Networking",
                            "Building out LinkedIn/Resume/Internships",
                            "Prioritizing academics/athletics each day/Time management",
                            "Understanding my mentee's strengths/grit/drive"]}
                            required={true}
                            max={2}
                            errors={errors.q9}/>
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <MultiSelect
                            name={"q10"}
                            control={control}
                            question={"8. I can help mentees with:"}
                            helper={["(Pick up to 5)"]}
                            options = {[ "Digital health", "Medicine",
                            "Healthcare", "Technology", "Analytics",
                            "Tech Sales", "Engineering", "Financial Services",
                            "FinTech Startups", "Small Business", "Entrepreneur",
                            "Athletics", "Elementary/Secondary Ed", "Coaching", "None of the above"]}
                            required={true}
                            max={5}
                            errors={errors.q10}/>
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <DayTimePicker
                            name={"q11"}
                            control={control}
                            setValue={setValue}
                            question={"9. The best days and time for me to mentor are..."}
                            helper={["Please add at least one 30 minutes slot on your desired day. You can add multiple slots.","This is your weekly schedule, and it can be changed."]}
                            required={true}
                            errors={errors.q11}/>
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <TextBox
                        name={"q12"}
                        control={control}
                        question={"10. Tell us a bit more about yourself. What would you like the students to know about you? What makes you unique?"}
                        helper={["Examples: I like dogs, I like watching football, I like pizza"]}
                        required={true}
                        errors={errors.q12}/>
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <TextBox
                        name={"q13"}
                        control={control}
                        question={"11. Tell us more about your areas of expertise and industry you work in."}
                        required={true}
                        errors={errors.q13}/>
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <TextBox
                        name={"q15"}
                        control={control}
                        question={"12. What are some of your hobbies?"}
                        required={true}
                        errors={errors.q15}/>
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <Dropdown
                            name={"q14"}
                            control={control}
                            question={"13. Where do you live?"}
                            options={Object.keys(countries).map(function(code) {return countries[code].name})}
                            required={true}
                            errors={errors.q14}/>
                    </ListItem>
                    <ListItem sx={{ p:2, my:1.5 }} className='question-block'>
                        <SingleSelect
                            name={"q16"}
                            control={control}
                            question={"I understand and agree to the following as a mentor in the ARISE:"}
                            helper={[
                                "1. ARISE will use a form of machine learning to better match me with a set of mentees.",
                                "2.	ARISE will help me become a better mentor my using data to inform me of insights we are all learning together.",
                                "3.	My mentees can / will likely change during this timeframe because the student athletes are driving the connections using the ARISE Algorithm.",
                                "4.	As part of this pilot, ARISE will use sentiment analysis to analyze my sessions with my mentee.",
                                "5.	As a mentor, I will follow these guidelines for the pilot:",
                                "6.	I will provide as many open slots (30 minutes in my calendar as possible for the next 13 weeks)",
                                "7.	I will only communicate with the pilot mentees within ARISE so that all the learnings are captured by our technology. (I can use DM or the communities to @mention)",
                                "8.	I will post one time per week a learning I am gaining from this pilot in either the mentor community or in “onto the next level” (this can be a shout out to my mentee or just something I want to share, an “aha moment”)",
                                "9.	I will attend 2 of the 3 Mentor Community connects during the 13 weeks. If I am unable to attend the second one, I will make myself available for a 30 minute session with our ARISE team.",
                                "10. I will leverage the Mentor tool kit frequently during this pilot.",
                                "11. I will complete my mentees out-take survey (20 seconds ) within 24 hours of each session I have to keep the data flow moving and the insights growing.",
                                "12. If there is ever a cause for concern or feedback, I will reach out to the ARISE team immediately (within 24 hours) as a responsible adult working with a young vulnerable population.",
                                "13. Auntedna.ai's mission is to disrupt the current professional landscape for rising Black and Brown leaders through data insights and analytics that can transform how companies operationalize their DEI commitment. We will ingesting your data into the algorithm which will measure the impact of our students building trusted relationships.",
                                "14. The above terms and conditions are subject to change. A notification will be sent when that change occurs.",
                                "If you would like to decline, please send an email to tracey@athleda.org"
                            ]}
                            options = {["I accept"]}
                            required={true}
                            errors={errors.q16}/>
                    </ListItem>
                </List>
                <Button type='submit' className="m-form-button" variant="outlined" onClick={handleSubmit(getTopMentors, onError)}>Submit</Button>
                </Box>
            </form>
        </div>
    )
}

export default MentorForm;